<script lang="ts">
  let { data }: { data: Record<string, unknown> } = $props()

  // Escaping `<` keeps a closing script tag inside a text from ending the JSON-LD early.
  const json = $derived(JSON.stringify(data).replaceAll('<', '\\u003c'))
</script>

<svelte:head>
  {@html `<script type="application/ld+json">${json}</script>`}
</svelte:head>
